import { sum, flatten } from "lodash"
import { Spinner } from "evergreen-ui"
import BaseCircuit from "./baseCircuit"
import fetchGradients from "./fetchGradients"

const norm = xs => {
  return sum(flatten(xs).map(x => x * x))
}

const layers = {
  inceptionv1: [
    "conv2d0",
    "conv2d1",
    "conv2d2",
    "mixed3a",
    "mixed3b",
    "mixed4a",
    "mixed4b",
    "mixed4c",
    "mixed4d",
    "mixed4d",
    "mixed4d",
    "mixed4e",
    "mixed5a",
    "mixed5b",
  ],
  alexnet: ["conv1_1", "conv2_1", "conv3_1"],
  inceptionv3: [
    "InceptionV3/InceptionV3/Conv2d_1a_3x3/Relu",
    "InceptionV3/InceptionV3/Conv2d_2a_3x3/Relu",
    "InceptionV3/InceptionV3/Conv2d_2b_3x3/Relu",
    "InceptionV3/InceptionV3/Conv2d_3b_1x1/Relu",
    "InceptionV3/InceptionV3/Conv2d_4a_3x3/Relu",
    "InceptionV3/InceptionV3/Mixed_5b/concat",
    "InceptionV3/InceptionV3/Mixed_5c/concat",
    "InceptionV3/InceptionV3/Mixed_5d/concat",
    "InceptionV3/InceptionV3/Mixed_6a/concat",
    "InceptionV3/InceptionV3/Mixed_6b/concat",
    "InceptionV3/InceptionV3/Mixed_6c/concat",
    "InceptionV3/InceptionV3/Mixed_6d/concat",
    "InceptionV3/InceptionV3/Mixed_6e/concat",
    "InceptionV3/InceptionV3/Mixed_7a/concat",
    "InceptionV3/InceptionV3/Mixed_7b/concat",
    "InceptionV3/InceptionV3/Mixed_7c/concat",
  ],
}

export default class Circuit extends Component {
  state = { loading: true, allGradients: {} }

  getModelName = () => {
    const { modelName = "inceptionv1" } = this.props
    return modelName
  }

  start = async () => {
    const { circuit } = this.props
    const modelName = this.getModelName()
    const allGradients = {}

    for (const layer of circuit) {
      for (const layer2 of circuit) {
        if (
          layers[modelName].indexOf(layer.name) >=
          layers[modelName].indexOf(layer2.name)
        )
          continue

        allGradients[layer.name + ":" + layer2.name] = await fetchGradients(
          modelName,
          layer.name,
          layer2.name,
        )
      }
    }

    this.setState({ allGradients, loading: false })
  }

  componentDidMount() {
    this.start()
  }

  render() {
    const { loading, allGradients } = this.state
    const {
      circuit,
      onAddNeuron = () => {},
      onAddGroup = () => {},
      onMouseEnter = () => {},
      onAddLayerBefore = () => {},
      onAddLayerAfter = () => {},
      onChangeState = null,
      circuitState = null,
      isDesigner = false,
      inlineLayerNames = false,
      circuitProps = {},
    } = this.props

    const modelName = this.getModelName()

    if (loading)
      return (
        <Surface margin={20} alignItems="center" justifyContent="center">
          <Spinner />
          <Text size={400} fontWeight={600} marginTop={10} opacity={0.7}>
            Loading Gradients
          </Text>
        </Surface>
      )

    const weights = {}

    const getGradient = (layer, neuron, layer2, neuron2) => {
      let value
      try {
        value = allGradients[layer + ":" + layer2][neuron][neuron2]
      } catch (err) {
        console.log("failed loading", layer, neuron, "2", layer2, neuron2)
      }
      return value
    }

    const getWeight = (layer, neuron, layer2, neuron2) => {
      const grad = getGradient(layer, neuron, layer2, neuron2)
      const total = norm(grad)

      return {
        grad,
        total,
      }
    }

    circuit.forEach(({ name: layer, modules }) => {
      modules.forEach(({ neurons }) => {
        neurons.forEach(neuron => {
          circuit.forEach(({ name: layer2, modules }) => {
            if (
              layers[modelName].indexOf(layer2) <=
              layers[modelName].indexOf(layer)
            )
              return

            modules.forEach(({ neurons: neurons2 }) => {
              neurons2.forEach(neuron2 => {
                weights[`${layer}:${neuron}-${layer2}:${neuron2}`] = getWeight(
                  layer,
                  neuron,
                  layer2,
                  neuron2,
                )
              })
            })
          })
        })
      })
    })

    return (
      <BaseCircuit
        inlineLayerNames={inlineLayerNames}
        modelName={modelName}
        key={1}
        onMouseEnter={onMouseEnter}
        isDesigner={isDesigner}
        getWeight={getWeight}
        onAddNeuron={onAddNeuron}
        onAddGroup={onAddGroup}
        onAddLayerBefore={onAddLayerBefore}
        onAddLayerAfter={onAddLayerAfter}
        circuitState={circuitState}
        onChangeState={onChangeState}
        {...circuitProps}
        data={{
          circuit,
          weights,
        }}
      />
    )
  }
}
